import React, { lazy } from "react";
import AuthorizeUser from "../../middleware/AuthorizeUser";
import LazyLoading from "../../common/components/LazyLoading/LazyLoading";
import { Navigate } from "react-router-dom";

const Customer = lazy(() => import("../../pages/Customer/Customer"));
const AddProperty = lazy(() =>
  import("../../pages/Customer/components/Add Property/AddProperty")
);
const CustomerPersonalInfo = lazy(() =>
  import("../../pages/Customer/components/PersonalInfo/PersonalInfo")
);
const AboutMe = lazy(() =>
  import(
    "../../pages/Customer/components/PersonalInfo/components/AboutMe/AboutMe"
  )
);
const Dashboard = lazy(() =>
  import("../../pages/Customer/Dashboard/Dashboard")
);
const OverView = lazy(() =>
  import("../../pages/Customer/Dashboard/overview/OverView")
);
const MyAddress = lazy(() =>
  import("../../pages/Customer/Dashboard/my-address/MyAddress")
);
const Credits = lazy(() =>
  import("../../pages/Customer/Dashboard/credits/Credits")
);
const Transactions = lazy(() =>
  import("../../pages/Customer/Dashboard/transactions/Transactions")
);

const MyProperty = lazy(() => import("../../pages/MyProperty/MyProperty"));

const customer = [
  {
    path: "",
    element: (
      <AuthorizeUser>
        <LazyLoading>
          <Customer />
        </LazyLoading>{" "}
      </AuthorizeUser>
    ),
    children: [
      {
        path: "personalinfo",
        element: (
          <LazyLoading>
            <CustomerPersonalInfo />
          </LazyLoading>
        ),
        children: [
          {
            path: "aboutme",
            element: (
              <LazyLoading>
                <AboutMe />
              </LazyLoading>
            ),
          },
          // {
          //   path: "kyc",
          //   element: <LazyLoading></LazyLoading>,
          // },
          // {
          //   path: "nominee",
          //   element: <LazyLoading></LazyLoading>,
          // },
          // {
          //   path: "settings",
          //   element: (
          //     <LazyLoading>
          //       <Settings />
          //     </LazyLoading>
          //   ),
          // },
        ],
      },
      {
        path: "addproperty",
        element: (
          <LazyLoading>
            <AddProperty />
          </LazyLoading>
        ),
      },
      {
        path: "dashboard",
        element: (
          <LazyLoading>
            <Dashboard />
          </LazyLoading>
        ),
        children: [
          {
            path: "",
            element: <Navigate to="overview" replace />,
          },
          {
            path: "overview",
            element: (
              <LazyLoading>
                <OverView />
              </LazyLoading>
            ),
          },
          {
            path: "credits",
            element: (
              <LazyLoading>
                <Credits />
              </LazyLoading>
            ),
          },
          {
            path: "my-address",
            element: (
              <LazyLoading>
                <MyAddress />
              </LazyLoading>
            ),
          },
          {
            path: "transactions",
            element: (
              <LazyLoading>
                <Transactions />
              </LazyLoading>
            ),
          },
        ],
      },
    ],
  },
];

export default customer;
